import Phaser from 'phaser';

export interface TextButtonOptions {
  width?: number;
  height?: number;
  fontSize?: string;
  backgroundColor?: number;
  hoverColor?: number;
}

/**
 * Dokunmatik uyumlu metin butonu.
 * Container yerine Rectangle kullanılır — Phaser 3 input güvenilirliği.
 */
export class TextButton {
  static create(
    scene: Phaser.Scene,
    x: number,
    y: number,
    label: string,
    onClick: () => void,
    options: TextButtonOptions = {},
  ): Phaser.GameObjects.Rectangle {
    const width = options.width ?? 360;
    const height = options.height ?? 88;
    const fontSize = options.fontSize ?? '32px';
    const backgroundColor = options.backgroundColor ?? 0x2d6cdf;
    const hoverColor = options.hoverColor ?? 0x3b7cff;

    const button = scene.add
      .rectangle(x, y, width, height, backgroundColor)
      .setStrokeStyle(0)
      .setInteractive({ useHandCursor: true });

    const text = scene.add
      .text(x, y, label, {
        fontFamily: 'Arial, sans-serif',
        fontSize,
        color: '#ffffff',
        fontStyle: 'bold',
      })
      .setOrigin(0.5)
      .disableInteractive();

    text.setDepth(button.depth + 1);

    const handleClick = () => {
      onClick();
    };

    button.on('pointerover', () => button.setFillStyle(hoverColor));
    button.on('pointerout', () => button.setFillStyle(backgroundColor));
    button.on('pointerdown', handleClick);

    return button;
  }
}
